// Quiet seller strip over the top of a listing-card photo (Haim runtime round 3):
// seller name + agency name (second line) in very small white text over a subtle
// blurred dark gradient, so it reads on any photo without shouting. Text is
// end-aligned and width-capped so it never collides with the badges the cards pin
// at the top-start corner. Renders only the lines that exist (private listings
// often have no agency); "N/A" seller names are treated as absent (legacy
// ListingsMatchRow's hasSellerInfo quirk, ported).
import { Box, Typography } from "@material-ui/core";

type SellerImageOverlayProps = {
  sellerName?: string;
  agencyName?: string;
};

export default function SellerImageOverlay({
  sellerName,
  agencyName
}: SellerImageOverlayProps): JSX.Element | null {
  const name = sellerName && sellerName !== "N/A" ? sellerName.trim() : "";
  const agency = agencyName?.trim() ?? "";
  if (!name && !agency) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        insetInline: 0,
        px: 1,
        pt: 0.5,
        pb: 1.5,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        pointerEvents: "none",
        color: "common.white",
        background:
          "linear-gradient(180deg, rgba(22,28,36,0.60) 0%, rgba(22,28,36,0.28) 55%, rgba(22,28,36,0) 100%)",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
        // fade the blur out together with the gradient — no hard strip edge
        maskImage: "linear-gradient(180deg, #000 55%, transparent 100%)",
        WebkitMaskImage: "linear-gradient(180deg, #000 55%, transparent 100%)"
      }}
    >
      {name && (
        <Typography
          noWrap
          title={name}
          sx={{
            fontSize: 11,
            fontWeight: 600,
            lineHeight: 1.35,
            maxWidth: "72%",
            textShadow: "0 1px 2px rgba(0,0,0,0.45)"
          }}
        >
          {name}
        </Typography>
      )}
      {agency && (
        <Typography
          noWrap
          title={agency}
          sx={{
            fontSize: 10,
            lineHeight: 1.3,
            opacity: 0.85,
            maxWidth: "72%",
            textShadow: "0 1px 2px rgba(0,0,0,0.45)"
          }}
        >
          {agency}
        </Typography>
      )}
    </Box>
  );
}
